@if (projects$ | async; as projects) {
    <div class="container-fluid container-xxl overflow-hidden gx-sm-9 gx-lg-10 gx-xxl-0">
        @for (project of projects; track project; let last = $last; let index = $index) {
            <div
                [ngClass]="{
                    'mb-13 mb-md-14': !last,
                }"
            >
                <app-project [project]="project" />
            </div>
        }
    </div>
}
